function saveAuthToCookie(value) {
  document.cookie = `authorization=${value}; path=/;`;
}

function saveUserToCookie(value) {
  document.cookie = `r_user=${value}`;
}

function saveTenantToCookie(value) {
  document.cookie = `r_tenant=${value}`;
}

function getAuthFromCookie() {
  return document.cookie.replace(
    /(?:(?:^|.*;\s*)authorization\s*=\s*([^;]*).*$)|^.*$/,
    '$1',
  );
}

function getUserFromCookie() {
  return document.cookie.replace(
    /(?:(?:^|.*;\s*)r_user\s*=\s*([^;]*).*$)|^.*$/,
    '$1',
  );
}

function getTenantFromCookie() {
  return document.cookie.replace(
    /(?:(?:^|.*;\s*)r_tenant\s*=\s*([^;]*).*$)|^.*$/,
    '$1',
  );
}

function deleteCookie(value) {
  document.cookie = `${value}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export {
  saveAuthToCookie,
  saveUserToCookie,
  saveTenantToCookie,
  getAuthFromCookie,
  getUserFromCookie,
  getTenantFromCookie,
  deleteCookie,
};
